


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Spin, Card } from "antd";
import {
  ReadOutlined,
  BookOutlined,
  TrophyOutlined,
  LoadingOutlined
} from "@ant-design/icons";
import CourseOverview from "./CourseOverview";
import courseService from "../../services/course.service";
import API_BASE from "../../config/apiConfig";
import CourseFullViewer from "./CourseFullViewer";
import NoteFinaleViewer from "../admin_and_user/NoteFinaleViewer";

const CourseDetails = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("1");

  const API_PROXY_URL = `${API_BASE}/images/proxy`;

  const getProxyImageUrl = (url) => {
    if (!url) return "/default-image.png";
    return `${API_PROXY_URL}?url=${encodeURIComponent(url)}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        console.log("🚀 Chargement des infos de base...");
        
        // const courseData = await courseService.getCourseBasic(id);
       const courseData = await courseService.getCourseDetails(id);

        setCourse(courseData);
        console.log("✅ Infos de base chargées:", courseData);

        const proxyUrl = getProxyImageUrl(courseData.image);
        setImageUrl(proxyUrl);

        console.log("✅ Page d'aperçu prête !");
        
      } catch (err) {
        console.error("❌ Erreur lors du chargement :", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleStartLearning = async () => {
    console.log("📚 Passage à l'onglet Contenu du cours...");
    setActiveTab("2");
    
    if (subjects.length === 0) {
      try {
        console.log("📋 Chargement des sujets...");
        const subjectList = await courseService.getSubjectsByCourse(id);
        setSubjects(subjectList);
        
        if (subjectList.length > 0) {
          setSelectedSubjectId(subjectList[0].id);
        }
        console.log("✅ Sujets chargés:", subjectList.length);
      } catch (err) {
        console.error("❌ Erreur chargement des sujets :", err);
      }
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        paddingTop: '100px', /* AJOUT pour header fixe */
        padding: '20px'
      }}>
        <Card style={{
          marginTop: '80px', /* AJOUT pour header fixe */
          borderRadius: 20,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          border: 'none',
          minHeight: '400px'
        }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
              color: "white"
            }}
          >
            <Spin 
              indicator={<LoadingOutlined style={{ fontSize: 60, color: 'white' }} spin />} 
              size="large" 
            />
            <div style={{ 
              marginTop: 30, 
              fontSize: 20,
              fontWeight: '500',
              textAlign: 'center'
            }}>
              Chargement du cours en cours...
            </div>
            <div style={{ 
              marginTop: 10, 
              fontSize: 14,
              opacity: 0.8,
              textAlign: 'center'
            }}>
              Veuillez patienter pendant que nous préparons votre contenu
            </div>
          </div>
        </Card>
      </div>
    );
  }

  const tabItems = [
    {
      key: "1",
      label: (
        <span style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: 10,
          padding: '8px 16px',
          borderRadius: 25,
          transition: 'all 0.3s ease'
        }}>
          <ReadOutlined style={{ 
            fontSize: 20, 
            color: "#667eea"
          }} />
          <span style={{ 
            fontSize: '16px',
            fontWeight: '600',
            color: '#667eea'
          }}>
            Aperçus
          </span>
        </span>
      ),
      children: <CourseOverview course={course} imageUrl={imageUrl} onStartLearning={handleStartLearning} />
    },
    {
      key: "2",
      label: (
        <span style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: 10,
          padding: '8px 16px',
          borderRadius: 25,
          transition: 'all 0.3s ease'
        }}>
          <BookOutlined style={{ 
            fontSize: 20, 
            color: "#52c41a"
          }} />
          <span style={{ 
            fontSize: '16px',
            fontWeight: '600',
            color: '#52c41a'
          }}>
            Contenu du cours
          </span>
        </span>
      ),
      children: <CourseFullViewer courseId={id} courseTitle={course?.title} />
    }
  ];

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
     
    }}>
      <NoteFinaleViewer courseId={id} />
      
      <Card style={{
        borderRadius: 20,
        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
        border: 'none',
        background: 'white'
      }}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          style={{ 
            padding: "20px 30px"
          }}
          tabBarGutter={60}
          tabBarStyle={{
            borderBottom: "3px solid #f0f2f5",
            marginBottom: "30px",
            paddingBottom: "15px"
          }}
          items={tabItems}
          tabBarExtraContent={
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              color: '#999',
              fontSize: 14
            }}>
              <TrophyOutlined />
              <span>Formation Premium</span>
            </div>
          }
        />
      </Card>
    </div>
  );
};

export default CourseDetails;